module.exports = __webpack_public_path__ + "static/media/utu.4d0e3aff.png";